// extracted by mini-css-extract-plugin
export default {"wrapper":"PagesNavigation_wrapper__X+uLl"};